module.exports = __webpack_public_path__ + "img/FQ.f11a1d4d.png";